import type { BoxProps } from "@mui/material";
import { Stack } from "@mui/material";
import type { Icon } from "@phosphor-icons/react";

type SidenavFooterButtonProps<T extends React.ElementType = "div"> = {
  children: React.ReactNode;
  component?: React.ElementType<T>;
  Icon: Icon;
} & BoxProps<T, { component?: React.ElementType<T> }>;

export default function SidenavFooterButton({ children, Icon }: SidenavFooterButtonProps) {
  return (
    <Stack
      direction="row"
      gap={1}
      sx={{
        alignItems: "center",
        gap: "1rem",
        cursor: "pointer",
        fontFamily: '"Montserrat", sans-serif',
        fontWeight: 800,
        textTransform: "none",
        borderRadius: "4px",
        p: "12px 15px",
        "&:hover": {
          bgcolor: "primary.light",
        },
      }}
    >
      <Icon size="24" />
      {children}
    </Stack>
  );
}
